import React from 'react';
import styled, { css } from 'styled-components';
import { Body } from '../../../../../../../Typography';
import useLocale from '../../../../../../../../hooks/useLocale';
import Icon from '../../../../../../../Icon';
import JustificationContainer from '../../../../../../../JustificationContainer';

export type Props = {
  amountOfOther: number;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
};

const text = {
  prefix: {
    nl: '...bekijk',
    en: '...check out',
  },
  postfix: {
    nl: 'andere diensten',
    en: 'other services',
  },
};

const Footer: React.FC<Props> = ({ amountOfOther, onClick }) => {
  const locale = useLocale();

  return (
    <Container onClick={onClick}>
      <JustificationContainer align="center" justification="start" gap="xxxs">
        <Body withoutMargin>{text.prefix[locale]}</Body>
        <AmountContainer justification="center" align="center">
          {amountOfOther}
        </AmountContainer>
        <Body withoutMargin>{text.postfix[locale]}</Body>
      </JustificationContainer>
      <IconContainer>
        <Icon name="arrow-right" />
      </IconContainer>
    </Container>
  );
};

const Container = styled.footer(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;

    gap: ${theme.space('xxs')};
    padding-right: ${theme.space('xxs')};
    padding-left: ${theme.space('xs')};

    transition: all 0.3s ease-out;

    &:hover {
      padding-right: ${theme.space('xxxs')};
    }

    p {
      color: ${theme.color('primary', 'text')};
    }
  `,
);

const AmountContainer = styled(JustificationContainer)(
  ({ theme }) => css`
    margin: 0;
    padding: 0;
    background-color: ${theme.color('secondary')};
    color: ${theme.color('secondary', 'text')};
    border-radius: ${theme.getSystem().border.radius.full};
    width: 1.5rem;
    height: 1.5rem;
  `,
);

const IconContainer = styled.div(
  ({ theme }) => css`
    width: 1rem;

    svg {
      color: ${theme.color('secondary', 'text')};
    }
  `,
);

export default Footer;
